module.exports = __webpack_public_path__ + "img/plant_02.6396dec7.jpg";